//  This directive catch scroll event of element and if scroll position is
//   near bottom then send callback to the method specified in directive attribute
function loadMoreOnScroll() {
  function link(scope, elem) {
    angular.element(elem).bind('scroll', function(event){
    var element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight)
      {
          scope.loadMoreOnScroll();
      }
    });
  }
return {
  scope: {
    'loadMoreOnScroll': '&'
  },
    link: link
  };
}

export default {
  name: 'loadMoreOnScroll',
  fn: loadMoreOnScroll
};

